import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetDataImportRecordsTypeEnum,
  MigrationControllerApi,
} from "../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../utils/utils";

interface UseGetDataImportProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  searchKey: string;
  providerGroupUuid?: string;
  xTENANTID?: string;
  type?: GetDataImportRecordsTypeEnum;
  status?: string;
}

/**
 * @author rajkumar rathod
 */
const useDataImportList = ({
  gridSorting,
  pagination,
  searchKey,
  providerGroupUuid,
  type,
  status,
  xTENANTID,
}: UseGetDataImportProps): useBaseContent<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "data-import",
      pageSize,
      pageIndex,
      searchKey,
      providerGroupUuid,
      type,
      gridSorting,
      status,
      xTENANTID,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new MigrationControllerApi(getConfigObject())
        .getDataImportRecords(
          pageIndex, //page
          pageSize, //size
          sortData?.field ?? undefined, // sortBy
          sortData?.sort ?? undefined, // sortDirection
          type, //type
          providerGroupUuid,
          status,
          xTENANTID //xTENANTID
        )
        .then((res) => res?.data),
  });
};

export default useDataImportList;
